import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import { navigate } from "../lib/router";
import TopBar from "../components/TopBar";
import { PROJECT_STATUS_LABEL, projectBadgeClass, timeAgo } from "../lib/format";
import type { ProjectStatus } from "@shared/schema";

const FILTERS: Array<{ key: string; label: string; statuses?: ProjectStatus[] }> = [
  { key: "all", label: "Усі" },
  { key: "analyzing", label: "Аналіз", statuses: ["ingesting", "analyzing", "planning"] },
  { key: "planned", label: "Сплановано", statuses: ["planned"] },
  { key: "generating", label: "Генерація", statuses: ["generating"] },
  { key: "ready", label: "Готові", statuses: ["ready"] },
];

export default function ProjectsPage() {
  const [filter, setFilter] = useState("all");
  const [q, setQ] = useState("");
  const projects = useQuery({ queryKey: ["projects"], queryFn: api.listProjects });

  const active = FILTERS.find((f) => f.key === filter)!;
  const list = (projects.data ?? [])
    .filter((p) => !active.statuses || active.statuses.includes(p.status))
    .filter((p) => p.name.toLowerCase().includes(q.toLowerCase()));

  return (
    <>
      <TopBar
        crumbs={["Проєкти"]}
        right={
          <button className="btn primary sm" onClick={() => navigate("/projects/new")}>
            + Новий проєкт
          </button>
        }
      />
      <div className="content">
        <div className="page-head">
          <div>
            <h1>Проєкти</h1>
            <div className="lead">Референс + ТЗ → сцени → перші кадри → відео для дизайнера.</div>
          </div>
        </div>

        <div className="toolbar">
          <input
            className="input search"
            placeholder="Пошук за назвою…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
          <div className="filters">
            {FILTERS.map((f) => (
              <div
                key={f.key}
                className={"filter" + (filter === f.key ? " active" : "")}
                onClick={() => setFilter(f.key)}
              >
                {f.label}
              </div>
            ))}
          </div>
        </div>

        {projects.isLoading ? (
          <div className="empty"><span className="spinner" /></div>
        ) : list.length === 0 ? (
          <div className="empty">
            <div className="big">🎬</div>
            <h2>Ще немає проєктів</h2>
            <div>Створи перший — встав референс із Foreplay і напиши ТЗ.</div>
            <div style={{ marginTop: 16 }}>
              <button className="btn primary" onClick={() => navigate("/projects/new")}>
                + Новий проєкт
              </button>
            </div>
          </div>
        ) : (
          <div className="grid cards">
            {list.map((p) => (
              <div key={p.id} className="card proj-card" onClick={() => navigate(`/projects/${p.id}/board`)}>
                <div className="thumb">
                  {p.coverUrl ? <img src={p.coverUrl} alt="" /> : <span>9:16</span>}
                  {p.sceneCount > 0 && (
                    <div className="progress-ring">
                      {p.videosReady}/{p.sceneCount}
                    </div>
                  )}
                </div>
                <div className="meta">
                  <div className="title">{p.name}</div>
                  <div className="sub">
                    <span className={"badge dot " + projectBadgeClass(p.status)}>
                      {PROJECT_STATUS_LABEL[p.status]}
                    </span>
                    <span>{timeAgo(p.updatedAt)}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
